import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const fmt = (n, isMoney) => {
    if (n == null || isNaN(n)) return '—';
    if (isMoney) return Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return Number(n).toLocaleString();
};

const KpiStrip = ({ rows, totalCount, accumulators }) => {
    const { t } = useTranslation();
    const values = useMemo(() => {
        if (!Array.isArray(rows) || rows.length === 0) return [];
        return (accumulators || []).map(acc => {
            const sum = rows.reduce((s, r) => s + (Number(r[acc.field]) || 0), 0);
            return { ...acc, value: sum };
        });
    }, [rows, accumulators]);

    if (!rows || rows.length === 0) return null;

    return (
        <div className="dg-kpi-strip">
            <div className="dg-kpi">
                <div className="dg-kpi-label">{t('Total rows')}</div>
                <div className="dg-kpi-value">{fmt(totalCount)}</div>
            </div>
            {values.map(v => (
                <div className="dg-kpi" key={v.field}>
                    <div className="dg-kpi-label">{t(v.label)} <span className="dg-kpi-scope">{t('(page)')}</span></div>
                    <div className="dg-kpi-value">{fmt(v.value, v.money)}</div>
                </div>
            ))}
            <div className="dg-kpi dg-kpi-meta">
                <div className="dg-kpi-label">{t('Showing')}</div>
                <div className="dg-kpi-value-sm">{t('{{count}} rows on this page', { count: rows.length })}</div>
            </div>
        </div>
    );
};

export default KpiStrip;
